let rollbarIsomorphic

if (process.env.NODE_ENV === 'test') {
  rollbarIsomorphic = require('./rollbar.test.js').default
} else if (process.env.NODE_ENV === 'development') {
  rollbarIsomorphic = require('./rollbar.development.js').default
} else {
  if (__SERVER__) { // eslint-disable-line
    rollbarIsomorphic = require('./rollbar.server.js').default
  } else {
    rollbarIsomorphic = require('./rollbar.client.js').default
  }
}

export default rollbarIsomorphic



// WEBPACK FOOTER //
// ./common/utils/rollbar/index.js